'use client';

import { c as _c } from "react/compiler-runtime";
import { Field, FieldContent, FieldDescription, FieldError, FieldLabel, InputGroup, InputGroupAddon, InputGroupText, InputGroupTextarea, Spinner } from '@repo/ui/components/start';
import { ComponentProps, ReactNode } from 'react';
import { ReadOnlyField, useReadOnly } from '../components/readonly.tsx';
import { useFieldContext } from '../lib/form-context.ts';
import { cn } from '@repo/ui/lib/utils';
export const FormTextarea = t0 => {
  const $ = _c(48);
  let className;
  let description;
  let label;
  let lengthLimit;
  let props;
  let t1;
  let t2;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      description,
      disabled: t1,
      isPending: t2,
      label,
      lengthLimit,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = description;
    $[3] = label;
    $[4] = lengthLimit;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
    $[8] = variant;
  } else {
    className = $[1];
    description = $[2];
    label = $[3];
    lengthLimit = $[4];
    props = $[5];
    t1 = $[6];
    t2 = $[7];
    variant = $[8];
  }
  const disabled = t1 === undefined ? false : t1;
  const isPending = t2 === undefined ? false : t2;
  const field = useFieldContext();
  let t3;
  if ($[9] !== field.state.meta.errors) {
    t3 = field.state.meta.errors ?? [];
    $[9] = field.state.meta.errors;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const errors = t3;
  const isReadOnly = useReadOnly();
  let t4;
  if ($[11] !== field.name || $[12] !== label) {
    t4 = label && typeof label === "string" ? <FieldLabel htmlFor={field.name}>{label}</FieldLabel> : label;
    $[11] = field.name;
    $[12] = label;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const fieldLabel = t4;
  if (isReadOnly) {
    const t5 = field.state.value || "-";
    let t6;
    if ($[14] !== fieldLabel || $[15] !== t5) {
      t6 = <ReadOnlyField label={fieldLabel}>{t5}</ReadOnlyField>;
      $[14] = fieldLabel;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  let t5;
  if ($[17] !== className) {
    t5 = cn(className);
    $[17] = className;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const t6 = isPending || disabled;
  let t7;
  if ($[19] !== field) {
    t7 = e => field.handleChange(e.target.value);
    $[19] = field;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = field.state.value ?? "";
  let t9;
  if ($[21] !== field.handleBlur || $[22] !== field.name || $[23] !== props || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t9 = <InputGroupTextarea className={t5} data-testid={field.name} disabled={t6} id={field.name} onBlur={field.handleBlur} onChange={t7} value={t8} {...props} data-sentry-element="InputGroupTextarea" data-sentry-source-file="form-textarea.tsx" />;
    $[21] = field.handleBlur;
    $[22] = field.name;
    $[23] = props;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== isPending) {
    t10 = isPending && <InputGroupAddon align="inline-end"><Spinner className="text-muted-foreground" /></InputGroupAddon>;
    $[29] = isPending;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== field.state.value?.length || $[32] !== lengthLimit) {
    t11 = lengthLimit && <InputGroupAddon align="block-end"><InputGroupText>{field.state.value?.length ?? 0}/{lengthLimit}</InputGroupText></InputGroupAddon>;
    $[31] = field.state.value?.length;
    $[32] = lengthLimit;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t9 || $[37] !== variant) {
    t12 = <InputGroup variant={variant} data-sentry-element="InputGroup" data-sentry-source-file="form-textarea.tsx">{t9}{t10}{t11}</InputGroup>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t9;
    $[37] = variant;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== description) {
    t13 = description && typeof description === "string" ? <FieldDescription>{description}</FieldDescription> : description;
    $[39] = description;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== errors) {
    t14 = <FieldError className="text-sm" errors={errors} data-sentry-element="FieldError" data-sentry-source-file="form-textarea.tsx" />;
    $[41] = errors;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== fieldLabel || $[44] !== t12 || $[45] !== t13 || $[46] !== t14) {
    t15 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormTextarea" data-sentry-source-file="form-textarea.tsx"><FieldContent data-sentry-element="FieldContent" data-sentry-source-file="form-textarea.tsx">{fieldLabel}{t12}{t13}{t14}</FieldContent></Field>;
    $[43] = fieldLabel;
    $[44] = t12;
    $[45] = t13;
    $[46] = t14;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  return t15;
};